import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motivos-no-entrega',
  templateUrl: './motivos-no-entrega.component.html',
  styleUrls: ['./motivos-no-entrega.component.scss']
})
export class MotivosNoEntregaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
